import { addOrganizationToUser } from '~services/api.helpers';
import { addToast } from '~features/toast/ducks';
import { initializeApp } from '~actions/rootActions';
import { setUserOrganization } from '~features/user/ducks';

export function selectOnboardingOrganization({ organizationId, navigate }) {
  return async dispatch => {
    try {
      const org = await addOrganizationToUser(organizationId);
      dispatch(setUserOrganization(org));
      dispatch(initializeApp(navigate));
      dispatch(addToast({ message: 'Yksikkö valittu', type: 'SUCCESS' }));
      navigate('/');
    } catch (e) {
      console.error('Failed user onboarding', e);
      dispatch(
        addToast({ message: 'Yksikön valinta epäonnistui', type: 'ERROR' })
      );
    }
  };
}
